/*
  Catálogo y avisos de regreso (tareas 27 y 29).

  1) Catálogo: existencia, orden y "Descuentos". Reemplaza el bloque "Catálogo: existencia y orden" de
     theme.js, que ya no se activa porque la lista de tarjetas ahora se marca con data-catalog-list
     (antes data-catalog-grid). En una limpieza de theme.js ese bloque se puede borrar.
     Cada tarjeta trae sus datos: precio, precio de mayoreo, fecha, si hay existencia y si tiene
     descuento (data-offer, de snippets/has-offer.liquid).
  2) Desde el catálogo, la tarjeta de un modelo agotado lleva a la ficha con ?avisame=1 y aquí se abre
     sola la ventana de avisos de STOQ (la app solo se carga en las fichas de producto).
*/
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* 1) Catálogo */
  const catalog = $('[data-catalog]');
  const grid = catalog && $('[data-catalog-list]', catalog);
  if (grid) {
    const cards = $$('[data-card]', grid);
    const stock = $('[data-catalog-stock]', catalog);
    const sort = $('[data-catalog-sort]', catalog);
    const count = $('[data-catalog-count]', catalog);
    const empty = $('[data-catalog-empty]', catalog);
    const emptyText = empty ? empty.textContent.trim() : '';
    const num = (card, key) => Number(card.dataset[key]);
    const isOffer = (card) => card.dataset.offer === 'true';
    const orders = {
      nuevo: (a, b) => num(b, 'date') - num(a, 'date'),
      menor: (a, b) => num(a, 'price') - num(b, 'price'),
      mayor: (a, b) => num(b, 'price') - num(a, 'price'),
      mayoreo: (a, b) => num(a, 'low') - num(b, 'low'),
      // Con "Descuentos" solo quedan los productos con descuento, del más nuevo al más antiguo.
      descuentos: (a, b) => num(b, 'date') - num(a, 'date'),
    };
    // Si en esta página no hay productos con descuento, la opción no se ofrece.
    if (!cards.some(isOffer)) $('option[value="descuentos"]', sort)?.remove();
    // Enlace directo: /collections/all?orden=descuentos
    const wanted = new URLSearchParams(location.search).get('orden');
    if (wanted && [...sort.options].some((option) => option.value === wanted)) sort.value = wanted;
    const apply = () => {
      const available = (card) => card.dataset.available === 'true';
      const offersOnly = sort.value === 'descuentos';
      // Los agotados siempre al final, sin importar el orden elegido.
      [...cards]
        .sort((a, b) => Number(available(b)) - Number(available(a)) || orders[sort.value](a, b))
        .forEach((card) => grid.appendChild(card));
      let shown = 0;
      cards.forEach((card) => {
        card.hidden = (stock.checked && !available(card)) || (offersOnly && !isOffer(card));
        if (!card.hidden) shown += 1;
      });
      count.textContent = shown;
      if (empty) {
        empty.hidden = shown > 0;
        empty.textContent = offersOnly ? empty.dataset.emptyOffers || emptyText : emptyText;
      }
    };
    stock.addEventListener('change', apply);
    sort.addEventListener('change', apply);
    apply();
  }

  /* 2) Aviso de regreso desde el catálogo */
  const params = new URLSearchParams(location.search);
  const data = params.get('avisame') === '1' ? $('[data-product-json]') : null;
  if (data) {
    let product = null;
    try {
      product = JSON.parse(data.textContent);
    } catch {
      product = null;
    }
    // Solo si el modelo está totalmente agotado; con sabores disponibles la ficha no abre nada.
    if (product && !product.available) {
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        const app = window._RestockRocket;
        if (app && typeof app.openModal === 'function') {
          clearInterval(timer);
          try {
            app.openModal(product);
            // Quita el parámetro para que al recargar la ventana no se vuelva a abrir.
            params.delete('avisame');
            const query = params.toString();
            history.replaceState(null, '', location.pathname + (query ? `?${query}` : '') + location.hash);
          } catch {
            // Si la app no responde, la ficha queda con su botón de siempre.
          }
        } else if (tries >= 25) {
          // Después de 5 s sin la app, la persona se queda en la ficha.
          clearInterval(timer);
        }
      }, 200);
    }
  }
})();